import React from "react";
import styles from "./Pausenspielraum.module.css";


export const Pausenspielraum = (props) => {
  return (
    <div className="wrapper">
         <section className="wrapperContent">

          <div className={styles.text}>
            <h2 className={styles.title}>Unser neuer Pausenspielraum ist eröffnet!</h2>
            <p className={styles.text}>
                Hier könnt ihr Spielzeug und Sportgeräte ausleihen – von Bällen
                über Springseile bis zu Hula-Hoop und Teamspielen.
                Bewegung, Spaß und Spiel – für jede Pause ein kleines Abenteuer!
            </p>

          </div>


     </section>

    </div>
  );
};
export default Pausenspielraum;
